import { useQuery } from '@tanstack/react-query';
import { analyticsService } from '../services/analytics.service';

const ANALYTICS_KEY = 'analytics';
const STALE_TIME = 5 * 60 * 1000; // 5 minutes

export function useActiveUsers() {
  return useQuery({
    queryKey: [ANALYTICS_KEY, 'active-users'],
    queryFn: () => analyticsService.getActiveUsers(),
    staleTime: STALE_TIME,
  });
}

export function useConnectionTrends(days: number = 30, granularity: 'day' | 'week' = 'day') {
  return useQuery({
    queryKey: [ANALYTICS_KEY, 'connection-trends', days, granularity],
    queryFn: () => analyticsService.getConnectionTrends(days, granularity),
    staleTime: STALE_TIME,
  });
}

export function useTopUsers(days: number = 30, limit: number = 10) {
  return useQuery({
    queryKey: [ANALYTICS_KEY, 'top-users', days, limit],
    queryFn: () => analyticsService.getTopUsers(days, limit),
    staleTime: STALE_TIME,
  });
}

export function useActionsBreakdown(days: number = 30) {
  return useQuery({
    queryKey: [ANALYTICS_KEY, 'actions-breakdown', days],
    queryFn: () => analyticsService.getActionsBreakdown(days),
    staleTime: STALE_TIME,
  });
}

export function useModuleUsage(days: number = 30) {
  return useQuery({
    queryKey: [ANALYTICS_KEY, 'module-usage', days],
    queryFn: () => analyticsService.getModuleUsage(days),
    staleTime: STALE_TIME,
  });
}

export function useAiUsagePerUser(days: number = 30) {
  return useQuery({
    queryKey: [ANALYTICS_KEY, 'ai-usage-per-user', days],
    queryFn: () => analyticsService.getAiUsagePerUser(days),
    staleTime: STALE_TIME,
  });
}

export function useUsersActivity() {
  return useQuery({
    queryKey: [ANALYTICS_KEY, 'users-activity'],
    queryFn: () => analyticsService.getUsersActivity(),
    staleTime: STALE_TIME,
  });
}
